<template>
  <div class="gift-board-card">
    <div style="float: right; padding: 10px">
      <span :data-text="infoText" class="tooltipInfo"
        ><img :src="infoIcon"
      /></span>
    </div>
    <div class="gift-board-detail"><img :src="icon" /></div>
    <div class="gift-board-label">{{ label }}</div>
    <div class="gift-board-group">
      <div class="gift-board-score" :style="cssVars">
        {{ valueCurrency }}
      </div>
      <span class="gift-board-quantity" v-if="quantity">
        <span class="gift-board-bar">|</span> {{ quantity }} presentes
      </span>
      <span
        class="gift-board-quantity"
        v-if="walletDetails && !walletIncomplete"
      >
        <span class="gift-board-bar">|</span>
        <a href="/carteira" class="see-details">Ver mais</a>
      </span>
      <span
        class="gift-board-quantity"
        v-else-if="walletDetails && walletIncomplete"
      >
        <span class="gift-board-bar">|</span>
        <img :src="infoErrorIcon" alt="Aviso" />
        <a href="/carteira" class="see-details">Cadastrar conta</a>
      </span>
    </div>
  </div>
</template>

<script>
import infoIcon from '@/assets/img/info.svg'
import infoErrorIcon from '@/assets/img/input-error.svg'

export default {
  data() {
    return {
      infoIcon,
      infoErrorIcon,
    }
  },

  props: {
    label: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      required: null,
    },
    value: {
      type: Number,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    quantity: {
      type: Number,
      default: null,
    },
    infoText: {
      type: String,
      default: null,
    },
    walletDetails: {
      type: Boolean,
      default: false,
    },
    walletIncomplete: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    valueCurrency() {
      const value = this.value ? this.value : 0
      return value.toLocaleString('PT-IN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      })
    },

    cssVars() {
      return {
        '--bg-color': this.color,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.see-details {
  text-decoration: none;
  color: inherit;
  outline: 0;
}
.gift-board-card {
  min-width: 260px;
  height: 190px;
  background-color: #fff;
  margin: 5px;
  border-radius: 16px;
  border: 1px solid #dde7f1;
  box-shadow: 0px 10px 8px rgba(93, 117, 141, 0.05);
  @media screen and (min-width: 744px) {
    flex: 1;
  }
}

.gift-board-card:hover {
  background-color: $neutrallightest;
}
.gift-board-label {
  text-align: left;
  font-size: 16px;
  font-weight: 700;
  color: $neutraldarkest;
  margin-top: 18px;
  margin-left: 24px;
  margin-bottom: 16px;
  justify-content: space-between;
  display: flex;
  margin-right: 8px;

  @media (max-width: 1024px) {
    margin-left: 16px;
    font-size: 14px;
  }
}
.gift-board-bar {
  margin-right: 8px;
}
.gift-board-detail {
  text-align: left;
  font-size: 14px;
  font-weight: 700;
  color: $neutraldarkest;
  margin-top: 24px;
  margin-left: 24px;
  justify-content: space-between;
  display: flex;
  vertical-align: middle;
  align-items: center;

  @media (max-width: 1024px) {
    margin-left: 16px;
  }
}
.gift-board-score {
  min-width: 124px;
  max-width: 156px;
  height: 40px;
  background-color: var(--bg-color);
  margin-left: 24px;
  border-radius: 8px;
  color: #0f9596;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 16px;
  padding-right: 16px;

  @media (max-width: 1024px) {
    min-width: 140px;
    font-size: 18px;
    margin-left: 16px;
    padding-left: 8px;
    padding-right: 8px;
  }
}

img {
  margin-top: 0px;
  margin-right: 0px;
}

.gift-board-group {
  display: flex;
  vertical-align: middle;
  align-items: center;
}

.gift-board-quantity {
  display: flex;
  align-items: center;
  padding-left: 16px;
  font-size: 16px;
  font-weight: 700;
  color: $neutral;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
  @media (max-width: 1024px) {
    font-size: 14px;
    padding-left: 8px;
  }
}

.tooltipInfo {
  position: relative;
}

.tooltipInfo:before {
  content: attr(data-text);
  position: absolute;
  transform: translateY(-50%);
  top: 65px;
  right: 10px;
  margin-left: 15px;
  width: 200px;
  padding: 10px;
  border-radius: 10px;
  background: $neutraldarkest;
  color: #fff;
  text-align: center;
  font-size: 14px;

  display: none;
}

.tooltipInfo:hover:before {
  display: block;
}
</style>
